export default __webpack_public_path__ + "static/l_team_alliance_colored-b075dd82d1f315901901fc5ac3a05da9.svg";